// components/customer/Overview.js
import React from "react";
import { Box } from "@mui/material";
import BankCard from "./common/BankCard";

export default function BankList({ data = [] }) {
  return (
    <Box sx={{ width: "100%", m: 0, p: 0 }}>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(3, 1fr)", // 3 equal columns
          },
          gap: 2, // space between cards, none on outer edges
          width: "100%",
        }}
      >
        {data.map((bank, idx) => (
          <Box key={idx} sx={{ display: "flex" }}>
            <BankCard {...bank} />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
